import axios from 'axios'
import apiList from './resource.js'

export default {
  // 获取专家团
  getInvestAdviser: function (data, successfn, errorfn) {
    return axios
      .get(apiList.appUrl.getInvestAdviser, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取学霸榜信息
  getRankList: function (data, successfn, errorfn) {
    return axios
      .get(apiList.appUrl.getRankList, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取用户自身学霸榜排名信息
  getUserRank: function (data, successfn, errorfn) {
    return axios
      .get(apiList.appUrl.getUserRank, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 课程列表获取
  courseList: function (data, successfn, errorfn) {
    return axios
      .get(apiList.appUrl.courseList, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 实名认证
  userCertificationPost: function (data, successfn, errorfn) {
    return axios.post(apiList.appUrl.userCertification, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 消息中心列表查询
  msgList: function (successfn, errorfn) {
    return axios.get(apiList.appUrl.msgList)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 获取公告列表
  getNotice: function (successfn, errorfn) {
    return axios.get(apiList.appUrl.getNotice)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 埋点
  appCollect: function (data, successfn, errorfn) {
    return axios.post(apiList.appUrl.collect, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/app.js